import React from 'react'
import translate from '../../../reusable/translate'
import ReportProgressIcon from '../../../reusable/ReportProgressIcon'

const ProgressIconContainer = ({ icon, label, progress, setProgress }) => {
    return (
        <div
            className={`progress-icon ${progress === icon ? "progress-icon-active" : ""}`}
            onClick={() => setProgress(icon)}
        >
            <ReportProgressIcon icon={icon}/>
            <p className="p text-align">{translate({textKey: label})}</p>
        </div>
    )
}

export default ProgressIconContainer


// WEBPACK FOOTER //
// ./src/components/profile/reports/components/ProgressIconContainer.jsx